<template>
    <div class="main_bd">
        <div class="head_title">Smart SMS Management</div>
        <div class="action_content" style="margin-top: 20px;">
            <div>
                <span style="padding-right: 20px;">Smart SMS Status Filter</span>
                <a-radio-group v-model="smart_sms_status" button-style="solid" @change="onChangeStatus">
                    <a-radio-button value="">
                        All
                    </a-radio-button>
                    <a-radio-button :value="0">
                        Draft
                    </a-radio-button>
                    <a-radio-button :value="1">
                        Waiting
                    </a-radio-button>
                    <a-radio-button :value="2">
                        Sending
                    </a-radio-button>
                    <a-radio-button :value="4">
                        Completed
                    </a-radio-button>
                </a-radio-group>
                <a-button type="link" style="margin-left: 10px; padding-left: 8px;" @click="refreshList">Refresh</a-button>
            </div>
        </div>
        <div class="mod_default_box permission">
            <a-table :pagination="false" :rowKey="data => data.id" :columns="columns" :data-source="smart_sms_list" >
                <template slot="status" slot-scope="text, data">
                    <span style="width: 90px; border-radius: 12px; text-align: center;" v-if="data.campaign_status == 0">
                        <a-tag color="pink">Draft</a-tag>
                    </span>
                    <span style="width: 90px; border-radius: 12px; text-align: center;" v-else-if="data.campaign_status == 1">
                        <a-tag color="orange">Sending</a-tag>
                    </span>
                    <span style="width: 90px; border-radius: 12px; text-align: center;" v-else-if="data.campaign_status == 2">
                        <a-tag color="blue">Sending</a-tag>
                    </span>
                    <span style="width: 90px; border-radius: 12px; text-align: center;" v-else-if="data.campaign_status == 4">
                        <a-tag color="green">Completed</a-tag>
                    </span>
                </template>
                <template slot="pay_status" slot-scope="text, data">
                    <div style="display: flex; flex-direction: column; align-items: flex-start; line-height: 1.4;">
                        <span style="min-height: 24px;">
                            <a-tag color="red" v-if="data.pay_status == 0">Unpaid</a-tag>
                            <a-tag color="green" v-else-if="data.pay_status == 4">Paid</a-tag>
                            <a-tag color="red" v-else-if="data.pay_status == 2">Refunded</a-tag>
                            <a-tag v-else>-</a-tag>
                        </span>
                        <span style="color: #666; margin-top: 2px;">{{ data.pay_method || '-' }}</span>
                    </div>
                </template>
                <template slot="schedule" slot-scope="text, data">
                    <p v-if="data.campaign_type == 'immediately'" style="width: 90px; border-radius: 12px; text-align: center;">
                        Immediately
                    </p>
                    <p v-else style="width: 90px; border-radius: 12px; text-align: center;">
                        Scheduled: {{data.send_date}} {{data.send_time}}
                    </p>
                </template>
                <template slot="info" slot-scope="text, data">
                    <p style="width: 90px; border-radius: 12px; text-align: left;">
                        {{ data.contact_count }} contacts
                    </p>
                    <p style="width: 90px; border-radius: 12px; text-align: left;">
                        {{ '$' + data.total_price }}
                    </p>
                </template>
                <div slot="action" slot-scope="text, data">
                    <div v-if="data.campaign_status == 0 && data.pay_status == 0">
                        <div style="height: 10px"></div>
                        <a style="color: #FD7858" @click="comfirm_pay(data)">Comfirm Pay & Send</a>
                    </div>
                    <div>
                        <div style="height: 10px"></div>
                        <a style="color: #000" @click="show_detail(data)">Show details</a>
                    </div>
                </div>
            </a-table>
            <a-pagination style="margin-top: 5px;" @change="turnPage" :pageSize="20" v-model="cur_page" :total="total_count" show-less-items />
        </div>
        <a-modal :visible="show_detail_modal" :title="'Smart SMS Detail - 《' + smart_sms_detail.campaign_name + '》' + ' (' + getCampaignStatusText(smart_sms_detail.campaign_status) + ')'" @ok="handleOk" @cancel="handleCancel" :width="1250" style="height: 600px; overflow: auto;">
            <div style="display: flex; flex-wrap: wrap; margin-bottom: 10px;">
                <div style="margin-right: 30px; margin-bottom: 8px;">Total SMS: <b>{{ detail_summary.total_sms }}</b></div>
                <div style="margin-right: 30px; margin-bottom: 8px;">Delivered: <b>{{ detail_summary.delivered_count }}</b></div>
                <div style="margin-right: 30px; margin-bottom: 8px;">Failed: <b>{{ detail_summary.failed_count }}</b></div>
                <div style="margin-right: 30px; margin-bottom: 8px;">Pending: <b>{{ detail_summary.pending_count }}</b></div>
                <div style="margin-right: 30px; margin-bottom: 8px;">Delivery Rate: <b>{{ detail_summary.delivery_rate }}</b></div>
                <div style="margin-left: auto; margin-bottom: 8px;">
                    <a-button type="link" @click="showRecallData">Recall Data</a-button>
                </div>
            </div>
            <a-collapse v-model="activeKey">
                <a-collapse-panel key="1" header="Message">
                    <img :src="smart_sms_detail.image_url" style="width: 200px; height: auto;" v-if="smart_sms_detail.image_url" />
                    <p style="white-space: pre-wrap; margin-top: 10px; font-size: 16px;">
                        {{ smart_sms_detail.text_message }}
                    </p>
                </a-collapse-panel>
                <a-collapse-panel key="2" :header="'Contact List (' + smart_sms_detail.contact_count + ')'">
                    <a-button type="link" style="padding-left: 0;" @click="refreshDetailList">Refresh</a-button>
                    <a-table :scroll="{ y: 300 }" :pagination="false" :rowKey="data => data.id" :columns="layer_columns" :data-source="layer_recipient_list" >
                    </a-table>
                    <a-pagination style="margin-top: 5px;" @change="turnLayerPage" :pageSize="20" v-model="layer_current" :total="layer_total_count" show-less-items />
                </a-collapse-panel>
            </a-collapse>
        </a-modal>
        <a-drawer :visible="show_recall_modal" title="Recall Data" @close="hideRecallData" :width="900">
            <div v-if="is_recall_loading" style="text-align: center; padding: 30px;">
                <a-spin />
            </div>
            <div v-else class="recall-dashboard">
                <div class="recall-kpi-grid">
                    <div class="recall-kpi-card">
                        <div class="recall-kpi-label">SMS Sent</div>
                        <div class="recall-kpi-value">{{ formatRecallNumber(recall_metrics.sms_count) }}</div>
                    </div>
                    <div class="recall-kpi-card recall-kpi-card--highlight">
                        <div class="recall-kpi-label">Recalled Parties</div>
                        <div class="recall-kpi-value recall-kpi-value--blue">{{ formatRecallNumber(recall_metrics.recalled_parties) }}</div>
                    </div>
                    <div class="recall-kpi-card recall-kpi-card--highlight">
                        <div class="recall-kpi-label">Party Recall Rate</div>
                        <div class="recall-kpi-value recall-kpi-value--blue">{{ recall_metrics.party_recall_rate }}</div>
                    </div>
                    <div class="recall-kpi-card recall-kpi-card--highlight">
                        <div class="recall-kpi-label">Total Recalled Guests</div>
                        <div class="recall-kpi-value recall-kpi-value--blue">{{ formatRecallNumber(recall_metrics.total_guests) }}</div>
                    </div>
                    <div class="recall-kpi-card recall-kpi-card--highlight">
                        <div class="recall-kpi-label">Guest Yield per SMS</div>
                        <div class="recall-kpi-value recall-kpi-value--blue">{{ recall_metrics.guest_yield_per_sms }}</div>
                    </div>
                    <div class="recall-kpi-card">
                        <div class="recall-kpi-label">Avg Party Size</div>
                        <div class="recall-kpi-value">{{ recall_metrics.avg_party_size }}</div>
                    </div>
                </div>

                <div class="recall-breakdown-title">Recall Breakdown</div>
                <div class="recall-breakdown-grid">
                    <div class="recall-breakdown-card">
                        <div class="recall-breakdown-card-title">Waitlist Recall</div>
                        <div class="recall-breakdown-metrics">
                            <div class="recall-breakdown-metric">
                                <div class="recall-breakdown-metric-label">Parties</div>
                                <div class="recall-breakdown-metric-value">{{ formatRecallNumber(recall_metrics.waitlist.parties) }}</div>
                            </div>
                            <div class="recall-breakdown-metric">
                                <div class="recall-breakdown-metric-label">Guests</div>
                                <div class="recall-breakdown-metric-value recall-breakdown-metric-value--blue">{{ formatRecallNumber(recall_metrics.waitlist.guests) }}</div>
                            </div>
                            <div class="recall-breakdown-metric">
                                <div class="recall-breakdown-metric-label">Avg Party Size</div>
                                <div class="recall-breakdown-metric-value">{{ recall_metrics.waitlist.avg_party_size }}</div>
                            </div>
                        </div>
                        <div class="recall-breakdown-footer">Guests recalled through waitlist activity.</div>
                    </div>
                    <div class="recall-breakdown-card">
                        <div class="recall-breakdown-card-title">Reservation Recall</div>
                        <div class="recall-breakdown-metrics">
                            <div class="recall-breakdown-metric">
                                <div class="recall-breakdown-metric-label">Parties</div>
                                <div class="recall-breakdown-metric-value">{{ formatRecallNumber(recall_metrics.reserve.parties) }}</div>
                            </div>
                            <div class="recall-breakdown-metric">
                                <div class="recall-breakdown-metric-label">Guests</div>
                                <div class="recall-breakdown-metric-value recall-breakdown-metric-value--blue">{{ formatRecallNumber(recall_metrics.reserve.guests) }}</div>
                            </div>
                            <div class="recall-breakdown-metric">
                                <div class="recall-breakdown-metric-label">Avg Party Size</div>
                                <div class="recall-breakdown-metric-value">{{ recall_metrics.reserve.avg_party_size }}</div>
                            </div>
                        </div>
                        <div class="recall-breakdown-footer">Reservation recalled guests show larger party size.</div>
                    </div>
                </div>

                <a-table :pagination="false" :columns="recall_columns" :data-source="recall_trend_list" :rowKey="record => record.date" />
            </div>
        </a-drawer>
    </div>
</template>

<script>
    import Vue from 'vue';

    import VueSweetalert2 from "vue-sweetalert2";
    Vue.use(VueSweetalert2);

    import { mapState, mapActions, mapMutations, mapGetters } from 'vuex';

    const columns = [
        {
            title: "Merchant Name",
            dataIndex: "sname",
            width: 150
        },
        {
            title: "Campaign Name",
            dataIndex: "campaign_name",
            width: 150
        },
        {
            title: "Campaign Status",
            dataIndex: "campaign_status",
            scopedSlots: { customRender: 'status' }
        },
        {
            title: "Campaign id",
            dataIndex: "campaign_id"
        },
        {
            title: "Info",
            dataIndex: "id",
            scopedSlots: { customRender: 'info' }
        },
        {
            title: "Schedule",
            dataIndex: "schedule",
            scopedSlots: { customRender: 'schedule' }
        },
        {
            title: "Pay",
            dataIndex: "pay_status",
            scopedSlots: { customRender: 'pay_status' }
        },
        {
            title: 'Action',
            dataIndex: 'action',
            scopedSlots: { customRender: 'action' }
        }
    ];

    export default {
        name: 'smart_sms_list',
        components: {
        },
        data() {
            return {
                sid: window.localStorage.getItem('sid'),
                columns,
                cur_page: 1,
                total_page: 0,
                total_count: 0,
                smart_sms_list: [],
                smart_sms_status: '',
                activeKey: ['1'],
                show_detail_modal: false,
                smart_sms_detail: {},

                layer_columns: [
                    {
                        title: '#',
                        dataIndex: 'index',
                        key: 'index',
                    },
                    {
                        title: 'Phone Number',
                        dataIndex: 'phone',
                        key: 'phone',
                    },
                    {
                        title: 'Status',
                        dataIndex: 'send_status_text',
                        key: 'send_status',
                    },
                    {
                        title: 'Remark',
                        dataIndex: 'msg',
                        key: 'msg',
                    },
                    {
                        title: 'Create Time',
                        dataIndex: 'create_time',
                        key: 'create_time',
                    },
                    {
                        title: 'Update Time',
                        dataIndex: 'update_time',
                        key: 'update_time',
                    }
                ],
                layer_current: 1,
                layer_total_page: 0,
                layer_total_count: 0,
                
                layer_recipient_list: [],
                detail_summary: {
                    total_sms: 0,
                    delivered_count: 0,
                    failed_count: 0,
                    pending_count: 0,
                    delivery_rate: '0%'
                },
                detail_summary_loading: false,
                show_recall_modal: false,
                is_recall_loading: false,
                recall_data: {},
                recall_columns: [
                    { title: 'Date', dataIndex: 'date', key: 'date' },
                    { title: 'Total Recall', dataIndex: 'total_count', key: 'total_count' },
                    { title: 'Waitlist Recall', dataIndex: 'waitlist_count', key: 'waitlist_count' },
                    { title: 'Reserve Recall', dataIndex: 'reserve_count', key: 'reserve_count' },
                ],
                recall_trend_list: []
            };
        },
        beforeMount() {
        },
        async created() {
            this.get_smart_sms_list();
        },
        watch: {
        },
        mounted() {

        },
        computed: {
            ...mapGetters({}),
            ...mapState({}),
            recall_metrics() {
                const sms_count = Number(this.recall_data.sms_count || 0);
                const recalled_parties = Number(this.recall_data.total_recall_count || 0);
                const waitlist_parties = Number(this.recall_data.waitlist_count || 0);
                const waitlist_guests = Number(this.recall_data.waitlist_people_count || 0);
                const reserve_parties = Number(this.recall_data.reserve_count || 0);
                const reserve_guests = Number(this.recall_data.reserve_people_count || 0);
                const total_guests = waitlist_guests + reserve_guests;

                return {
                    sms_count,
                    recalled_parties,
                    party_recall_rate: this.formatRecallPercent(recalled_parties, sms_count),
                    total_guests,
                    guest_yield_per_sms: this.formatRecallPercent(total_guests, sms_count),
                    avg_party_size: this.formatRecallAvg(total_guests, recalled_parties),
                    waitlist: {
                        parties: waitlist_parties,
                        guests: waitlist_guests,
                        avg_party_size: this.formatRecallAvg(waitlist_guests, waitlist_parties),
                    },
                    reserve: {
                        parties: reserve_parties,
                        guests: reserve_guests,
                        avg_party_size: this.formatRecallAvg(reserve_guests, reserve_parties),
                    },
                };
            },
        },
        methods: {
            ...mapActions({
                getSmartSmsList: 'market/getSmartSmsList',
                confirmSmartSmsPay: 'market/confirmSmartSmsPay',
                getSmartSmsLogs: 'market/getSmartSmsLogs',
                getSmartSmsLogSummary: 'market/getSmartSmsLogSummary',
                getSmartSmsRecallData: 'market/getSmartSmsRecallData',
            }),
            ...mapMutations({
                set_msg: 'app/APP_SET_MSG'
            }),
            async get_smart_sms_list() {
                let res = await this.getSmartSmsList({
                    campaign_status: this.smart_sms_status,
                    page: this.cur_page,
                    page_size: 20
                });

                this.smart_sms_list = res.list;
                this.total_count = res.total_count;
                this.total_page = res.total_page;
            },
            refreshList() {
                this.get_smart_sms_list();
            },
            onChangeStatus(e) {
                this.cur_page = 1;
                this.get_smart_sms_list();
            },
            async comfirm_pay(data) {
                this.$confirm({
                    title: 'Confirm',
                    content: 'Are you sure you want to confirm the payment? This action will send the message immediately.',
                    onOk: async () => {
                        let res = await this.confirmSmartSmsPay({
                            campaign_id: data.campaign_id
                        });
                        if (res && res.campaign_id) {
                            this.$message.success('Payment confirmed, campaign is queued.');
                            this.get_smart_sms_list();
                        }
                    }
                });
            },
            async show_detail(data) {
                this.show_detail_modal = true;
                this.smart_sms_detail = data;
                this.layer_current = 1;
                this.resetDetailSummary();

                if (data.campaign_status < 2) {
                    this.layer_recipient_list = data.contact_list.split(',').map((item, index) => {
                        return {
                            index: index + 1,
                            phone: item,
                            send_status_text: 'Pending',
                        }
                    });
                    this.layer_total_count = this.layer_recipient_list.length;
                    this.buildDetailSummary();
                } else {
                    await this.get_smart_sms_logs();
                    await this.get_full_logs_summary();
                }
            },
            async get_smart_sms_logs() {
                let res = await this.getSmartSmsLogs({
                    campaign_id: this.smart_sms_detail.campaign_id,
                    page: this.layer_current,
                    page_size: 20,
                });

                this.layer_total_page = res.total_page;
                this.layer_total_count = res.total_count;
                this.layer_recipient_list = (res.list || []).map((item, index) => {
                    return {
                        ...item,
                        index: item.index || index + 1,
                        create_time: this.formatTimeToSecond(item.create_time, item.create_timestamp),
                        update_time: this.formatTimeToSecond(item.update_time, item.update_timestamp)
                    };
                });
                this.buildDetailSummary();
            },
            refreshDetailList() {
                if (this.smart_sms_detail.campaign_status < 2) {
                    this.show_detail(this.smart_sms_detail);
                    return;
                }
                this.get_smart_sms_logs();
                this.get_full_logs_summary();
            },
            getCampaignStatusText(status) {
                const mapper = {
                    0: 'Draft',
                    1: 'Waiting',
                    2: 'Sending',
                    4: 'Completed'
                };

                return mapper[status] || 'Unknown';
            },
            formatTimeToSecond(timeText, timestamp) {
                if (timestamp) {
                    const d = new Date(timestamp * 1);
                    if (!isNaN(d.getTime())) {
                        const pad = (n) => String(n).padStart(2, '0');
                        const year = d.getFullYear();
                        const month = pad(d.getMonth() + 1);
                        const day = pad(d.getDate());
                        const hour = pad(d.getHours());
                        const min = pad(d.getMinutes());
                        const sec = pad(d.getSeconds());
                        return `${year}/${month}/${day} ${hour}:${min}:${sec}`;
                    }
                }

                if (timeText && /^\d{4}\/\d{2}\/\d{2}\s\d{2}:\d{2}$/.test(timeText)) {
                    return `${timeText}:00`;
                }

                return timeText || '';
            },
            resetDetailSummary() {
                this.detail_summary = {
                    total_sms: 0,
                    delivered_count: 0,
                    failed_count: 0,
                    pending_count: 0,
                    delivery_rate: '0%'
                };
            },
            buildDetailSummary() {
                const totalSms = Number(this.smart_sms_detail.contact_count || this.layer_total_count || 0);
                let delivered = 0;
                let failed = 0;
                let pending = 0;

                this.layer_recipient_list.forEach(item => {
                    const statusText = String(item.send_status_text || '').toLowerCase();

                    if (statusText.includes('deliver') || statusText.includes('success')) {
                        delivered += 1;
                    } else if (
                        statusText.includes('fail') ||
                        statusText.includes('error') ||
                        statusText.includes('undeliver') ||
                        statusText.includes('cancel')
                    ) {
                        failed += 1;
                    } else {
                        pending += 1;
                    }
                });

                const denominator = totalSms || this.layer_recipient_list.length || 0;
                const rate = denominator > 0 ? `${((delivered / denominator) * 100).toFixed(2)}%` : '0%';

                this.detail_summary = {
                    total_sms: totalSms,
                    delivered_count: delivered,
                    failed_count: failed,
                    pending_count: pending,
                    delivery_rate: rate
                };
            },
            async get_full_logs_summary() {
                if (!this.smart_sms_detail.campaign_id) {
                    return;
                }

                this.detail_summary_loading = true;
                try {
                    const res = await this.getSmartSmsLogSummary({
                        campaign_id: this.smart_sms_detail.campaign_id,
                    });
                    const summary = res.summary || {};
                    const totalSms = Number(this.smart_sms_detail.contact_count || summary.total_count || 0);

                    this.detail_summary = {
                        total_sms: totalSms,
                        delivered_count: Number(summary.delivered_count || 0),
                        failed_count: Number(summary.failed_count || 0),
                        pending_count: Number(summary.pending_count || 0),
                        delivery_rate: summary.delivery_rate || '0%'
                    };
                } finally {
                    this.detail_summary_loading = false;
                }
            },
            async showRecallData() {
                if (!this.smart_sms_detail.campaign_id) {
                    return;
                }

                this.show_recall_modal = true;
                this.is_recall_loading = true;
                try {
                    const res = await this.getSmartSmsRecallData({
                        campaign_id: this.smart_sms_detail.campaign_id
                    });
                    const info = res.info || {};
                    this.recall_data = info;
                    this.recall_trend_list = info.recall_count_by_date_trend || [];
                } finally {
                    this.is_recall_loading = false;
                }
            },
            hideRecallData() {
                this.show_recall_modal = false;
            },
            formatRecallNumber(value) {
                return Number(value || 0).toLocaleString();
            },
            formatRecallPercent(numerator, denominator) {
                if (!denominator) {
                    return '0%';
                }
                return `${((numerator / denominator) * 100).toFixed(1)}%`;
            },
            formatRecallAvg(guests, parties) {
                if (!parties) {
                    return '0';
                }
                return (guests / parties).toFixed(2);
            },
            turnLayerPage(page) {
                this.layer_current = page;
                this.get_smart_sms_logs();
            },
            turnPage(page) {
                this.cur_page = page;
                this.get_smart_sms_list();
            },
            handleOk() {
                this.show_detail_modal = false;
            },
            handleCancel() {
                this.show_detail_modal = false;
            }
        }
    };
</script>

<style scoped>
.recall-dashboard {
    padding-bottom: 8px;
}

.recall-kpi-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 12px;
    margin-bottom: 24px;
}

.recall-kpi-card {
    background: #fff;
    border: 1px solid #e8e8e8;
    border-radius: 8px;
    padding: 16px 18px 18px;
    min-height: 88px;
}

.recall-kpi-card--highlight {
    border-top: 4px solid #1890ff;
}

.recall-kpi-label {
    color: #666;
    font-size: 13px;
    margin-bottom: 8px;
}

.recall-kpi-value {
    color: #262626;
    font-size: 28px;
    font-weight: 600;
    line-height: 1.2;
}

.recall-kpi-value--blue {
    color: #1890ff;
}

.recall-breakdown-title {
    font-size: 16px;
    font-weight: 600;
    color: #262626;
    margin-bottom: 12px;
}

.recall-breakdown-grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 12px;
    margin-bottom: 24px;
}

.recall-breakdown-card {
    background: #fff;
    border: 1px solid #e8e8e8;
    border-radius: 8px;
    padding: 18px 20px 16px;
}

.recall-breakdown-card-title {
    font-size: 15px;
    font-weight: 600;
    color: #262626;
    margin-bottom: 16px;
}

.recall-breakdown-metrics {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 12px;
    margin-bottom: 14px;
}

.recall-breakdown-metric-label {
    color: #8c8c8c;
    font-size: 12px;
    margin-bottom: 6px;
}

.recall-breakdown-metric-value {
    color: #262626;
    font-size: 22px;
    font-weight: 600;
    line-height: 1.2;
}

.recall-breakdown-metric-value--blue {
    color: #1890ff;
}

.recall-breakdown-footer {
    color: #8c8c8c;
    font-size: 12px;
    border-top: 1px solid #f0f0f0;
    padding-top: 12px;
}
</style>